import {NgModule} from '@angular/core';

import {AccountComponent} from './account/account.component';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {BlogItemComponent} from './network/blog-item/blog-item.component';
import {CandidateClauseComponent} from './candidate-clause/candidate-clause.component';
import {CertificateItemComponent} from './network/certificate-item/certificate-item.component';
import {ClauseItemComponent} from './clause/clause-item.component';
import {ClientComponent} from './client/client.component';
import {ClientInterviewQuestionnaireComponent} from './interviews/questionnaires/client-interview-questionnaire/client-interview-questionnaire.component';
import {ClientInterviewQuestionnaireHistoryComponent} from './interviews/questionnaires/client-interview-questionnaire/history/client-interview-questionnaire-history.component';
import {ConferenceItemComponent} from './network/conference-item/conference-item.component';
import {ConnectionGraphComponent} from './graph/connection-graph.component';
import {ContactComponent} from './contact/contact.component';
import {CoreModule} from '@core/core.module';
import {CvParsedInputComponent} from './cvs/cv-parsed-input/cv-parsed-input.component';
import {CvsComponent} from './cvs/cvs.component';
import {DialogComponent} from './dialog/dialog.component';
import {DialogCVPreviewComponent} from './dialog/dialog.cv-preview.component';
import {DialogParseCvComponent} from './dialog/dialog.parse.cv.component';
import {DialogService} from './dialog/dialog.service';
import {EcvProjectModule} from './ecv-project/ecv-project.module';
import {EducationComponent} from './education/education.component';
import {EducationItemComponent} from './education/education-item.component';
import {ExperienceComponent} from './experience/experience.component';
import {ExperienceItemComponent} from './experience/experience-item.component';
import {ExpertClausesComponent} from './clause/expert-clauses.component';
import {FinishEcvComponent} from './finish-ecv/finish-ecv.component';
import {FlowComponent} from './flow/flow.component';
import {FlowDirective} from './flow/flow.directive';
import {HeaderComponent} from './header/header.component';
import {LoginComponent} from './login/login.component';
import {NetworkComponent} from './network/network.component';
import {PersonalDataComponent} from './personal-data/personal-data.component';
import {ProcessClausesComponent} from './clause/process-clauses.component';
import {PublicationItemComponent} from './network/publication-item/publication-item.component';
import {CandidateQualificationQuestionnaireComponent} from './interviews/questionnaires/candidate-qualification-questionnaire/candidate-qualification-questionnaire.component';
import {CandidateQualificationQuestionnaireEditYearsComponent} from './interviews/questionnaires/candidate-qualification-questionnaire/candidate-qualification-questionnaire-edit-years.component';
import {CandidateQualificationQuestionnaireHistoryComponent} from './interviews/questionnaires/candidate-qualification-questionnaire/history/candidate-qualification-questionnaire-history.component';
import {RankingComponent} from './ranking/ranking.component';
import {CandidateQualificationComponent} from './interviews/candidate-qualification/candidate-qualification.component';
import {SharedModule} from './shared/shared.module';
import {ClientInterviewComponent} from './interviews/client-interview/client-interview.component';
import {TrainingItemComponent} from './network/training-item/training-item.component';
import {WebSearchComponent} from './web-search/web-search.component';
import {WidgetsModule} from '@widgets/widgets.module';
import {AcceptClauseComponent} from './candidate-clause/accept-clause.component';
import {DeclineClauseComponent} from './candidate-clause/decline-clause.component';
import {NgRedux, NgReduxModule} from 'ng2-redux';
import {IAppState, INITIAL_STATE, rootReducer} from './store';
import {FileSaverService} from './shared/file-saver-service';
import {DialogGoogleScholarPublicationsComponent} from './dialog/dialog.google-scholar-publications.component';
import {RankingSearchComponent} from './ranking/ranking-search/ranking-search.component';
import {DialogGithubProfilesComponent} from './dialog/dialog.github-profiles.component';
import {PhoneInterviewComponent} from './interviews/phone-interview/phone-interview.component';
import {PhoneInterviewQuestionnaireComponent} from './interviews/questionnaires/phone-interview-questionnaire/phone-interview-questionnaire.component';
import {PhoneInterviewQuestionnaireHistoryComponent} from './interviews/questionnaires/phone-interview-questionnaire/history/phone-interview-questionnaire-history.component';
import {PhoneInterviewQuestionnaireEditYearsComponent} from './interviews/questionnaires/phone-interview-questionnaire/phone-interview-questionnaire-edit-years.component';
import {DialogWikipediaAnchorsComponent} from './ecv-project/dialog/dialog.wikipedia-anchors/dialog.wikipedia-anchors.component';
import {RankingEditYearsComponent} from './ranking/ranking-search/ranking-edit-years.component';
import {DictPanelComponent} from './dict-panel/dict-panel.component';
import {DialogDictAliasComponent} from './dialog/dialog.dict-alias.component';
import {CoordinatorsComponent} from './coordinators/coordinators.component';
import {DeleteSpecialistComponent} from './delete-specialist/delete-specialist.component';

const COMPONENTS = [
  AcceptClauseComponent,
  DeclineClauseComponent,
  AccountComponent,
  AppComponent,
  BlogItemComponent,
  CandidateClauseComponent,
  CertificateItemComponent,
  ClauseItemComponent,
  ClientComponent,
  ClientInterviewQuestionnaireComponent,
  ClientInterviewQuestionnaireHistoryComponent,
  ConferenceItemComponent,
  ConnectionGraphComponent,
  ContactComponent,
  CvParsedInputComponent,
  CvsComponent,
  EducationComponent,
  EducationItemComponent,
  ExperienceComponent,
  ExperienceItemComponent,
  ExpertClausesComponent,
  FinishEcvComponent,
  HeaderComponent,
  LoginComponent,
  NetworkComponent,
  PersonalDataComponent,
  ProcessClausesComponent,
  PublicationItemComponent,
  PhoneInterviewQuestionnaireComponent,
  PhoneInterviewQuestionnaireHistoryComponent,
  PhoneInterviewQuestionnaireEditYearsComponent,
  CandidateQualificationQuestionnaireComponent,
  CandidateQualificationQuestionnaireHistoryComponent,
  CandidateQualificationQuestionnaireEditYearsComponent,
  RankingComponent,
  RankingEditYearsComponent,
  PhoneInterviewComponent,
  CandidateQualificationComponent,
  ClientInterviewComponent,
  TrainingItemComponent,
  WebSearchComponent,
  RankingSearchComponent,
  FlowComponent,
  FlowDirective,
  DictPanelComponent,
  CoordinatorsComponent,
  DeleteSpecialistComponent
];


const ENTRY_COMPONENTS = [
  DialogComponent,
  DialogGithubProfilesComponent,
  DialogParseCvComponent,
  DialogCVPreviewComponent,
  DialogGoogleScholarPublicationsComponent,
  DialogWikipediaAnchorsComponent,
  DialogDictAliasComponent
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...ENTRY_COMPONENTS,
  ],
  imports: [
    CoreModule,
    SharedModule,
    EcvProjectModule,
    WidgetsModule.forRoot(),
    AppRoutingModule,
    NgReduxModule
  ],
  providers: [
    DialogService,
    FileSaverService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [...ENTRY_COMPONENTS]
})

export class AppModule {
  constructor(ngRedux: NgRedux<IAppState>) {
    ngRedux.configureStore(rootReducer, INITIAL_STATE);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/app.module.ts